import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Entities/Home";
import { Nefrosys } from "./Entities/pages/Nefrosys";
import { UNEFRO } from "./Entities/pages/UNEFRO";
import { CitaConfirmada } from "./Entities/CitaConfirmada";
import { Consulta } from "./Entities/Consulta";
import { App as AppProd } from "./Entities/App";
import { Inicio } from "./Entities/Inicio";
import "rsuite/dist/rsuite.min.css";
import '@coreui/coreui/dist/css/coreui.min.css'
import "./App.css";
import { Pacientes } from "./Entities/Pacientes";
import { Citas } from "./Entities/Citas";
import { Horarios } from "./Entities/Horarios";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" Component={Nefrosys} />
        <Route path="/App/Home" Component={Home} />
        <Route path="/App/Home/Citas" Component={Citas} />
        <Route path="/App/Home/Pacientes" Component={Pacientes} />
        <Route path="/App/Home/Consulta" Component={Consulta} />
        <Route path="/App/Home/Horarios" Component={Horarios} />
        <Route path="/App" Component={AppProd} />
        <Route path="/App/Inicio" Component={Inicio} />
        <Route path="/App/Inicio/Consulta" Component={Consulta} />
        <Route path="/UNEFRO" Component={UNEFRO} />
        <Route path="/CitaConfirmada/:id/:phone" Component={CitaConfirmada} />
      </Routes>
    </Router>
  );
}

export default App;
